package io.eqoty.shared.datalayer.functions

import io.eqoty.shared.datalayer.Repository
import io.eqoty.shared.datalayer.sources.web3.Web3Network
import io.eqoty.shared.datalayer.sources.web3.network

suspend fun Repository.getWeb3Network(): Web3Network? = withRepoContext {
    return@withRepoContext web3Provider?.getId().network
}